import {db} from "@/firebase";
import HistoricStorage from "@/services/storage/HistoricStorage";

const project_historic_ref = db.collection("project_historics");

async function saveHistoric(historic) {
    try {
        const historicExists = await project_historic_ref
            .where('month', '==', historic.month)
            .where('id_project', '==', historic.id_project)
            .get()

        if (!historicExists.empty) return [false, "Já existe um histórico com essas referências cadastrado"]

        // Guardar referência do arquivo se existir
        const fileToUpload = historic.file_photo_account;
        const fileName = fileToUpload ? fileToUpload.name : null;
        
        // Remover campos temporários antes de salvar no Firestore
        const historicToSave = { ...historic };
        delete historicToSave.file_photo_account;
        delete historicToSave._shouldDeleteFile;
        
        // Primeiro salva o histórico para obter o ID
        const result = await project_historic_ref.add(historicToSave)
        await result.update({id_doc: result.id})
        
        const historicId = result.id;
        
        let filePath = null;
        
        // Se houver arquivo, faz upload
        if (fileToUpload) {
            try {
                filePath = await HistoricStorage.uploadFile(
                    historic.id_project, 
                    historicId, 
                    fileToUpload
                );
                
                // Atualiza o histórico com o caminho do arquivo
                await result.update({
                    path_file_photo_account: filePath,
                    file_photo_account_name: fileName
                });
            } catch (uploadErr) {
                console.error("Erro ao fazer upload do arquivo:", uploadErr);
                // Continua mesmo se o upload falhar
            }
        }
        
        // Retorna ID e dados do arquivo para atualizar o objeto local
        return [true, {
            id: historicId,
            path_file_photo_account: filePath,
            file_photo_account_name: fileName
        }];
    } catch (err) {
        console.error("saveHistoric:", err);
        throw err;
    }
}

async function saveHistoricList(historics) {
    try {
        let historics_response = [];

        for (let historic of historics) {
            const [status, result] = historic.id_doc ? await updateHistoric(historic) : await saveHistoric(historic)

            if (status) {
                if (!historic.id_doc) historic.id_doc = result;
                historics_response.push({historic: historic, saved: status})
            } else {
                const response = {
                    historic: historic,
                    saved: status,
                    motive: result
                }
                historics_response.push(response)
            }
        }

        return historics_response
    } catch (err) {
        console.error("saveHistoricList:", err);
        throw err;
    }

}

async function updateHistoric(historic) {
    try {
        const historicRef = project_historic_ref.doc(historic.id_doc)
        
        // Buscar dados antigos para pegar o caminho do arquivo antigo
        const oldHistoricSnapshot = await historicRef.get();
        const oldHistoric = oldHistoricSnapshot.data();
        
        // Se houver novo arquivo
        if (historic.file_photo_account) {
            // Deletar arquivo antigo se existir
            if (oldHistoric?.path_file_photo_account) {
                try {
                    await HistoricStorage.deleteFile(oldHistoric.path_file_photo_account);
                } catch (deleteErr) {
                    console.error("Erro ao deletar arquivo antigo:", deleteErr);
                }
            }
            
            // Fazer upload do novo arquivo
            try {
                const filePath = await HistoricStorage.uploadFile(
                    historic.id_project, 
                    historic.id_doc, 
                    historic.file_photo_account
                );
                
                historic.path_file_photo_account = filePath;
                historic.file_photo_account_name = historic.file_photo_account.name;
            } catch (uploadErr) {
                console.error("Erro ao fazer upload do novo arquivo:", uploadErr);
            }
        } else if (historic._shouldDeleteFile && oldHistoric?.path_file_photo_account) {
            // Arquivo foi removido - deletar do Storage
            try {
                await HistoricStorage.deleteFile(oldHistoric.path_file_photo_account);
                historic.path_file_photo_account = null;
                historic.file_photo_account_name = null;
            } catch (deleteErr) {
                console.error("Erro ao deletar arquivo removido:", deleteErr);
            }
        }
        
        // Remover campos temporários antes de salvar
        const historicToSave = { ...historic };
        delete historicToSave.file_photo_account;
        delete historicToSave._shouldDeleteFile;
        
        await historicRef.update(historicToSave)

        const historicSnapshot = await historicRef.get();

        return [true, historicSnapshot.data()]
    } catch (err) {
        console.error("updateHistoric:", err);
        throw err;
    }

}

async function deleteHistoric(historic) {
    try {
        // Deletar arquivo do Storage se existir
        if (historic.path_file_photo_account) {
            try {
                await HistoricStorage.deleteFile(historic.path_file_photo_account);
            } catch (deleteErr) {
                console.error("Erro ao deletar arquivo do Storage:", deleteErr);
                // Continua mesmo se falhar ao deletar o arquivo
            }
        }
        
        // Deletar documento do Firestore
        const historic_ref = project_historic_ref.doc(historic.id_doc)
        await historic_ref.delete();
        return true;
    } catch (err) {
        console.error("deleteHistoric:", err);
        throw err;
    }
}

async function deleteHistoricList(historicList) {
    try {
        // Deletar arquivos do Storage primeiro
        const deleteFilePromises = historicList.map(historic => {
            if (historic.path_file_photo_account) {
                return HistoricStorage.deleteFile(historic.path_file_photo_account)
                    .catch(err => {
                        console.error(`Erro ao deletar arquivo ${historic.path_file_photo_account}:`, err);
                        // Não bloqueia o processo se falhar
                    });
            }
            return Promise.resolve();
        });
        
        await Promise.all(deleteFilePromises);
        
        // Deletar documentos do Firestore em batch
        const batch = db.batch();
        historicList.forEach(doc => {
            const docRef = project_historic_ref.doc(doc.id_doc);
            batch.delete(docRef);
        });
        await batch.commit();
        return true;
    } catch (err) {
        console.error("deleteHistoricList:", err);
        throw err;
    }
}

async function getAllHistoricsByProjectId(project_id) {
    let historics = [];

    const historicsSnapshot = await project_historic_ref
        .where('id_project', '==', project_id)
        .get()

    historicsSnapshot.forEach((historic) => {
        historics.push(historic.data());
    })

    historics.sort((a, b) => {
        return a.month.localeCompare(b.month);
    });

    return historics;

}


export default {
    saveHistoric,
    saveHistoricList,
    updateHistoric,
    deleteHistoric,
    deleteHistoricList,
    getAllHistoricsByProjectId,

}

